var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.999,
    cy: 60.9912,
    r: 51.6279,
    fill: "#0195D3",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6837 44.3335L48.6504 50.3835",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3164 44.3335L71.3497 50.3835",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.334 54.0858C43.334 51.0024 44.984 50.7524 47.034 50.7524H72.9673C75.0173 50.7524 76.6673 51.0024 76.6673 54.0858C76.6673 57.6691 75.0173 57.4191 72.9673 57.4191H47.034C44.984 57.4191 43.334 57.6691 43.334 54.0858Z",
    stroke: "#0195D3",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2676 64.3335V70.2502",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9336 64.3335V70.2502",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.834 57.6665L48.184 72.0665C48.7173 75.2998 50.0007 77.6665 54.7673 77.6665H64.8173C70.0007 77.6665 70.7673 75.3998 71.3673 72.2665L74.1673 57.6665",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60.9883,
    r: 59.5,
    stroke: "#D9EFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalAccount);
export default __webpack_public_path__ + "static/media/delete-modal-account.7efb83d1b883b507c16d7021421e173d.svg";
export { ForwardRef as ReactComponent };